import React from "react";
import { useAppSelector } from "redux/hooks";
import { selectIsLoggedIn } from "redux/slices/LoginSlice";

const useAuth = (): boolean => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn);

  return isLoggedIn;
};

export default useAuth;
